// Date/time parsing helpers for the dashboard.
//
// Why this exists: the backend serializes datetimes from Column(TIMESTAMP)
// (no timezone) as naive ISO strings like "2026-05-29T12:00:00" — no "Z",
// no offset. JavaScript's Date constructor interprets ISO strings WITHOUT
// a timezone designator as *local* time, which means a user in CEST
// (UTC+2) sees a 2-hour offset on every "minutes ago" / "tab open since"
// label.
//
// parseServerDate() normalizes server timestamps to UTC by appending "Z"
// when no offset is present. It also tolerates already-tz-aware strings
// (e.g. "2026-05-29T12:00:00Z" or "+02:00") and Date instances.
//
// Use this anywhere we parse a timestamp that came from the backend.
// For "now" we still use Date.now() / new Date() — those are local-clock
// reads, not server values.

const TZ_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/;

export function parseServerDate(value) {
  if (value == null) return null;
  if (value instanceof Date) return value;
  if (typeof value !== "string") return new Date(value);
  // Already has a timezone designator → trust it.
  if (TZ_SUFFIX.test(value)) return new Date(value);
  // Looks like an ISO datetime missing a tz → treat as UTC.
  // (Date-only strings like "2026-05-29" are spec'd as UTC already; we
  // only patch values that contain a "T".)
  if (value.includes("T")) return new Date(value + "Z");
  return new Date(value);
}
